import {updateWishlist} from '../../../../../../../../Packages/Tms/Tms.Wishlist/Resources/Private/JavaScript/Wishlist'

function addProductOptionParameters() {
    let url = new URL(window.location.href.split('?')[0]);
    document.getElementById('product-options').querySelectorAll('.custom-select').forEach(function(element) {
        if (element.value)
            url.searchParams.set(element.id,element.value);
    });
    window.history.pushState({}, '', url);
}
let productOptions = document.getElementById('product-options');
if(productOptions) {
    productOptions.addEventListener('change', addProductOptionParameters);
    productOptions.addEventListener('change', modifyWishlistButton);
}

function getProductOptions() {
    let url = new URL(window.location);
    let productOptions = document.getElementById('product-options');
    if(!productOptions)
        return;

    productOptions.querySelectorAll('.custom-select').forEach(function(element) {
        let value = url.searchParams.get(element.id);
        if (value) element.value = value;
    });
    modifyWishlistButton();
    updateWishlist();
}
getProductOptions();

function modifyWishlistButton() {
    let productOptions = document.getElementById('product-options');
    let identifier = productOptions.getAttribute('data-product-identifier');
    let identifierProductOptions = identifier + '__';

    productOptions.querySelectorAll('.custom-select').forEach(function(element) {
        if (element.value)
            identifierProductOptions += element.id + element.value;
    });

    document.querySelectorAll('[data-wishlist-item-identifier-baseproduct="' + identifier + '"]').forEach(function(button) {
        button.setAttribute('data-wishlist-item-identifier', identifierProductOptions);

        let properties = button.getAttribute('data-wishlist-item-properties');
        if (properties) {
            properties = JSON.parse(properties);

            let url = new URL(window.location.href.split('?')[0]);
            let subtitleParts = [];
            subtitleParts.push(properties.subtitle.split('<br/>')[0]);

            productOptions.querySelectorAll('.custom-select').forEach(function(element) {
                if (element.value) {
                    url.searchParams.set(element.id,element.value);
                    subtitleParts.push('+ ' + element[element.selectedIndex].innerHTML + ' (' + element.value + ')')
                }
            });

            properties.href = url;
            properties.subtitle = subtitleParts.join('<br/>');
            button.setAttribute('data-wishlist-item-properties', JSON.stringify(properties));
        }
    });
    updateWishlist();
}